import api from "./httpService";

export const addEmployeeService = async (payload: any) => {
    const response = await api.post("/coaches", payload);
    return response.data;
};

export const getEmployees = async () => {
    const response = await api.get("/coaches");
    return response.data;
};

export const updateEmployeeService = async (employeeId: string, payload: any) => {
    const response = await api.put(`/coaches/${employeeId}`, payload);
    return response.data;
};

export const deleteEmployeeService = async (employeeId: string) => {
    const response = await api.delete(`/coaches/${employeeId}`);
    return response.data;
};
